import * as cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader'

/**
 * Headers limpios en CDN R2 propio (p. ej. r2-*.tanjousoft.com.ar) además de S3/R2 nativo.
 */
export function isPresignedObjectStorageUrl(url) {
  const u = String(url || '')
  if (/X-Amz-Signature=|X-Amz-Credential=|X-Amz-Algorithm=/i.test(u)) return true
  // Host R2 / S3 / CDN custom sin Orthanc
  if (
    (/r2\.cloudflarestorage\.com/i.test(u) ||
      /\.r2\.dev\b/i.test(u) ||
      /amazonaws\.com/i.test(u) ||
      /s3[.-]/i.test(u) ||
      /^https?:\/\/r2[-.]/i.test(u) ||
      (/tanjousoft\.com\.ar/i.test(u) && /\/tjs\w+\//i.test(u) && !/visorweb/i.test(u))) &&
    !/visorweb/i.test(u) &&
    !/\/wado\b/i.test(u)
  ) {
    return true
  }
  return false
}

/**
 * ¿URL WADO / Orthanc proxy del visor?
 * @param {string} url
 * @returns {boolean}
 */
export function isOrthancWadoUrl(url) {
  return /visorweb|\/wado\b/i.test(String(url || ''))
}

/**
 * Configura cornerstone-wado-image-loader:
 * - R2/S3 firmado: beforeSend no setea ningún header (headers limpios)
 * - Orthanc WADO: Basic del PACS activo
 *
 * Credenciales del PACS (pacsConfig); nunca hardcodear usuario/pass ni keys R2.
 *
 * @param {{ username?: string, password?: string } | null} credentials
 */
export function configureWadoLoaderAuth(credentials) {
  const user = credentials && credentials.username != null ? String(credentials.username) : ''
  const pass = credentials && credentials.password != null ? String(credentials.password) : ''
  const orthancAuth =
    user && typeof btoa !== 'undefined' ? btoa(`${user}:${pass}`) : ''

  cornerstoneWADOImageLoader.configure({
    beforeSend(xhr, imageId) {
      const url = String(imageId || '').replace(/^wadouri:/, '')
      // R2 / S3: no Authorization, no custom headers
      if (isPresignedObjectStorageUrl(url)) {
        return
      }
      if (isOrthancWadoUrl(url) && orthancAuth) {
        xhr.setRequestHeader('Authorization', `Basic ${orthancAuth}`)
      }
    },
  })
}
